<template>
    <div id="toolbar" class="f-row">
        <!-- <slider :drawer="drawer" @update="updateDrawer"></slider> -->

            <!-- <organization-selector
                v-if="IsAuthenticated && HasUser && LinksLoadedAuth">
            </organization-selector> -->

            <!-- <v-app-bar-nav-icon color="#fff" @click.stop="drawer = !drawer">
            </v-app-bar-nav-icon> -->

			<!-- <router-link
			v-if="IsAuthenticated"
            class="home"
            :to="{name: 'login'}" exact> -->
			<a @click="logout"
				v-if="IsAuthenticated"
				class="home">
				<v-icon color="#fff" large>mdi-logout</v-icon>
			</a>
			<!-- </router-link> -->

			<router-link
            class="home"
            :to="{name: 'dashboard'}" exact>
				<v-icon color="#fff" large>mdi-home</v-icon>
			</router-link>
            <v-spacer></v-spacer>
            <logo></logo>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import namespace from '../store/namespace';
import Logo from './Logo.vue';

export default {
	name: 'NavToolbar',
	components: {
		Logo,
	},
	data() {
		return {
			// drawer: false,
		};
	},
	computed: {
		...mapGetters(namespace.USER, ['HasUser']),
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
		...mapGetters(['LinksLoaded', 'LinksLoadedAuth']),
	},
	methods: {
		logout() {
			const logout = confirm(this.$t('text.confirm.logoff'));
			if (logout) {
				this.$router.push({
					name: 'login',
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../globalComponents/style/_globals";

#toolbar {
	border-bottom: solid 2px $seltec_color;
	background-color: $prim_bg_color;
}

a {
	text-decoration: none;
	margin: 5px 10px;
	margin-right:0px;
}

</style>
